<template>
  <div v-if="show">
    <card class="mb-4" shadow noBody>
      <template v-slot:header>
        <div class="bg-white border-0">
          <div class="row align-items-top">
            <div class="col-8">
              <h3 class="mb-0">Tips</h3>
            </div>
            <div class="col-4 text-right"></div>
          </div>
        </div>
      </template>
      <div class="card-body">
        <small>FUTURE: view tips by location</small>
      </div>
    </card>
  </div>
</template>
<script>
import copy from "copy-to-clipboard";

export default {
  mounted() {},
  components: {},
  props: ["location"],
  data() {
    return {
      show: false,
      edit: false,
      inputs: {},
    };
  },
  computed: {},
  methods: {
    async copyUrl(url) {
      copy(url);
    },
    async openUrl(url) {
      window.open(url, "_blank");
    },
  },
};
</script>

<style lang="scss"></style>
